import React from 'react'
import styled from 'styled-components'

const Header = styled.div`
  > h1 {
    margin-bottom: 5px;

    @media print {
      display: none;
    }
  }
`
const Subtitle = styled.p`
  padding: 0 0 10px;
  font-size: 12px;
  line-height: 16px;

  @media print {
    display: none;
  }
`

const HeaderTitle = () => (
  <Header>
    <h1>Bingoo</h1>
    <Subtitle>
      Created by{' '}
      <a href="http://markanthonyuy.com" rel="noopener">
        Mark Anthony Uy
      </a>{' '}
      dedicated to my lovely wife B.K.F.I.U.
    </Subtitle>
  </Header>
)

export default React.memo(HeaderTitle)
